var _desc, _defs, _rect, _rect2, _g, _text, _text2, _rect3, _circle, _path, _text3, _rect4, _text4, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Makey room rental marketplace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A stylized room rental marketplace showing searchable property cards.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7f1ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9a66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b5e3c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 14,
    floodColor: "#153d35",
    floodOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#background)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 54,
    width: 1060,
    height: 568,
    rx: 30,
    fill: "#fffdf9",
    filter: "url(#shadow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#123f37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 127 171 88l48 39v59h-35v-41h-26v41h-35z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 239,
    y: 158,
    fontFamily: "Arial, sans-serif",
    fontSize: 54,
    fontWeight: 700
  }, "MAKEY"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 242,
    fill: "#123f37",
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: 700
  }, "Find a room that feels like home.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 284,
    fill: "#58706b",
    fontFamily: "Arial, sans-serif",
    fontSize: 24
  }, "Browse rooms to rent across South Africa.")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 326,
    width: 682,
    height: 74,
    rx: 18,
    fill: "#f4f6f3",
    stroke: "#cad8d3",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 363,
    r: 13,
    fill: "none",
    stroke: "#58706b",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m177 373 15 15",
    stroke: "#58706b",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 373,
    fill: "#71827e",
    fontFamily: "Arial, sans-serif",
    fontSize: 23
  }, "Search Cape Town, Johannesburg, Durban...")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 824,
    y: 326,
    width: 243,
    height: 74,
    rx: 18,
    fill: "#123f37"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 877,
    y: 373,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Search rooms")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 130,
    rx: 20,
    fill: "url(#room)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 102,
    height: 65,
    rx: 7,
    fill: "#f7e6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 87h246v43H22z",
    fill: "#6f4931",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 52,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Furnished room"), /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 82,
    fill: "#fff4e4",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "R4,500 / month"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(455 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 130,
    rx: 20,
    fill: "#759b8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 93 91 34l58 46 38-31 83 67v14H20z",
    fill: "#dce9e3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 52,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Private room"), /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 82,
    fill: "#eef7f3",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "R3,800 / month"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(777 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 130,
    rx: 20,
    fill: "#d7b56d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 59,
    r: 32,
    fill: "#fff1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 111c7-24 22-36 30-36s23 12 30 36",
    fill: "#f4dfaa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 52,
    fill: "#43351f",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Move-in ready"), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 82,
    fill: "#5b4929",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "R5,200 / month"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakey);
export default __webpack_public_path__ + "static/media/makey.f4e6a762482e06772ddfb3647c10a7fd.svg";
export { ForwardRef as ReactComponent };